export default theme => ({
  root: {},
  panel: {
    padding: theme.spacing(1),
  },
});
